import React from "react";
import {Dialog} from "@mui/material";
import {AdminLessonPageContent} from "../../Lessons/AdminLessonPageContent";
import type {LessonResponse} from "@/app2/shared/data";

/**
 * Lesson Editor Modal
 *
 * Full-screen dialog with the same create/edit lesson UI as the standalone admin lesson page.
 */
export interface IProps {
	lessonId?: number;
	onClose: () => void;
	onSave: (lesson: {id: number; title: string; slug: string; publishedAt: Date | null}) => void;
	onDelete: (lessonId: number) => void;
}

export const LessonEditorModal: React.FC<IProps> = ({lessonId, onClose, onSave, onDelete}) => {
	const handleSaveResponse = (data: LessonResponse): void => {
		onSave({
			id: data.id,
			title: data.title,
			slug: data.slug,
			publishedAt: data.publishedAt ? new Date(data.publishedAt) : null
		});
	};

	const handleDeleteResponse = (): void => {
		if (lessonId !== undefined) {
			onDelete(lessonId);
		}
	};

	const handleGetResponse = (data: LessonResponse | null, statusCode?: number): void => {
		if (statusCode === 404) {
			onClose();
			return;
		}
		if (data && lessonId !== undefined && data.id !== lessonId) {
			onSave({
				id: data.id,
				title: data.title,
				slug: data.slug,
				publishedAt: data.publishedAt ? new Date(data.publishedAt) : null
			});
		}
	};

	const handleCancel = (event: {}, reason: "backdropClick" | "escapeKeyDown"): void => {
		if (reason && reason === "backdropClick") {
			return;
		}
		onClose();
	};

	return (
		<Dialog 
			open 
			fullWidth={true} 
			maxWidth="md" 
			onClose={handleCancel}
		>
			<AdminLessonPageContent
				lessonId={lessonId}
				onSaveResponse={handleSaveResponse}
				onDeleteResponse={handleDeleteResponse}
				onGetResponse={handleGetResponse}
				onCancel={onClose}
				type="modal"
			/>
		</Dialog>
	);
};
